export const SET_CONTAINER: string = 'set_container'
export const SET_ACTIVITY: string = "set_activity"
export const SET_ACTIVITY_ITEMS: string = "set_activity_items"